import React from 'react';
import Header from './components/Header';
import MainGrid from './components/MainGrid';
import PageContainer from './components/common/PageContainer';

export default function Dashboard() {
  // ダッシュボードは横幅をフルに使う (maxWidth='none')
  return (
    <PageContainer maxWidth="none">
      <Header />
      <MainGrid />
    </PageContainer>
  );
}
